import { Component, OnInit, Input } from '@angular/core';
import { Benefit } from '@fgb/core';

@Component({
  selector: 'fgb-benefit-claimed',
  templateUrl: './benefit-claimed.component.html',
  styleUrls: ['./benefit-claimed.component.scss']
})
export class BenefitClaimedComponent implements OnInit {

  @Input() benefit: Benefit;

  constructor() { }

  ngOnInit() {
  }

}
